module.exports = __webpack_public_path__ + "fonts/Mulish-Black.4116253e.ttf";